var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-16 -14 64 64",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 21.3V11.7H7.9096L16 1.572 24.0904 11.7H18v9.6H14Zm4.24 1.5a1.35 1.35 90 001.36-1.3476V13.2h4.5072a1.3368 1.3368 90 001.32-.84 1.4988 1.4988 90 00-.18-1.6164L17.0008.4464A1.3536 1.3536 90 0014.9992.4416L6.748 10.7484A1.4988 1.4988 90 006.5428 12.36a1.3368 1.3368 90 001.2084.84H12.4v8.2524A1.35 1.35 90 0013.76 22.8h4.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 18v10c0 2.2092-1.7908 4-4 4H4c-2.2092 0-4-1.7908-4-4V18H1.6v9c0 2 1.4 3.4 3.4 3.4h22c2 0 3.4-1.4 3.4-3.4V18H32Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon--share.cff0ed4cf6ae552b023cbffa8a754393.svg";
export { ForwardRef as ReactComponent };